import UserManagementComponent from '../Components/UserManagementComponent';

function UserManagementPage() {
  return <UserManagementComponent />;
}

export default UserManagementPage;
